import {inject, InjectionToken} from '@angular/core';
import {Apollo} from 'apollo-angular';
import {firstValueFrom} from 'rxjs';
import {CRD_DRM_SESSION} from '../../queries-repository';
import {CrdDrmSession} from './drm-transport';

export interface CrdDrmSessionInput {
  pool: string;
  hostInstance: string;
  session: string;
}

/** Fetches the DRM session for one viewer (re)connect; a CLEAR mode carries no token or keys. */
export const CRD_DRM_SESSION_SOURCE = new InjectionToken<(input: CrdDrmSessionInput) => Promise<CrdDrmSession>>(
  'crd-drm-session', {
    providedIn: 'root',
    factory: () => {
      const apollo = inject(Apollo);
      return async (input: CrdDrmSessionInput) => {
        const res = await firstValueFrom(apollo.query<{crdDrmSession: CrdDrmSession}>({
          query: CRD_DRM_SESSION,
          variables: {input},
          fetchPolicy: 'network-only',   // a fresh token on every (re)connect
        }));
        return res.data!.crdDrmSession;
      };
    },
  });
